var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "my-attendance" } }, [
    !_vm.isEventAttendance
      ? _c(
          "div",
          { staticClass: "attendance-wrapper" },
          [
            _c("AttendanceTitle", {
              attrs: {
                sideBar: _vm.sidebarProps,
                cntAttendance: _vm.cnt_attendance,
              },
            }),
            _c("div", { attrs: { id: "attendance_subtitle" } }, [
              _vm._v(_vm._s(_vm.$t("mypage.attendance.subtitle"))),
            ]),
            _vm.attendanceEvent?.isEvent !== null
              ? _c("EventAttendanceBoard", {
                  attrs: { cnt_attendance: _vm.cnt_attendance },
                })
              : _c("AttendanceBoard", {
                  attrs: { cnt_attendance: _vm.cnt_attendance },
                }),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "attendance-wrapper event" },
          [
            _c("div", { staticClass: "event-title" }, [
              _vm._v(_vm._s(_vm.texts.omz.title)),
            ]),
            _c("div", { staticClass: "event-content" }, [
              _vm._v(_vm._s(_vm.texts.omz.content)),
            ]),
            _c("OmzAttendance", {
              attrs: { usrAttend: _vm.cnt_attendance, type: "sidebar" },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }